import { store } from '@/store';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import de from '@/lang/de';
import en from '@/lang/en';
import es from '@/lang/es';
import fi from '@/lang/fi';
import fr from '@/lang/fr';
import it from '@/lang/it';
import ja from '@/lang/ja';
import nl from '@/lang/nl';
import no from '@/lang/no';
import pl from '@/lang/pl';
import ptBR from '@/lang/pt-BR';
import ptPT from '@/lang/pt-PT';
import sr from '@/lang/sr';
import sv from '@/lang/sv';
import tr from '@/lang/tr'

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: store.getters.lang ?? 'en',
    fallbackLocale: 'en',
    messages: {
        de,
        en,
        es,
        fi,
        fr,
        it,
        ja,
        nl,
        no,
        pl,
        'pt-BR': ptBR,
        'pt-PT': ptPT,
        sr,
        sv,
        tr,
    },
});

document.documentElement.lang = i18n.locale;

export default i18n;